import ajax from "@/lib/ajax";

const URLs = {
    RESET_PSW: "/xiaoyue-operation/login/changePassword"
};

export async function resetPassWord(oldPsw, newPsd) {
    const request = {
        password: oldPsw,
        new_password: newPsd
    };

    let successed = false;
    try {
        const ret = await ajax.post(URLs.RESET_PSW, request);
        successed = ret.set_new_password;
    } catch (err) {
        successed = false;
    }

    return successed;
}
